<template>
  <v-app>
    <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12">
          <v-breadcrumbs>
            <v-breadcrumbs-item>
              <router-link to="/">Home</router-link>
            </v-breadcrumbs-item>
            <span class="divider">></span>
            <v-breadcrumbs-item disabled>
              Contact Us
            </v-breadcrumbs-item>
          </v-breadcrumbs>
        </v-col>
      </v-row>
      
      <v-row no-gutters class="px-5">
        <v-col cols="12">
        <h1>Contact Us</h1>
          <v-row>
            <v-col cols="12">
              <iframe
                  width="100%"
                  height="400"
                  frameborder="0"
                  style="border:0"
                  :src="mapUrl"
                  allowfullscreen
                  ></iframe>
              <p>
                Borneo Parking Systems Sdn. Bhd. (Co. No. 923282-V)<br>
                One Stop Center, Miri City Council,<br>
                Jalan Raja, 98000 Miri, Sarawak, Malaysia <br>
                Tel: 085 – 418734<br>
                Fax: 085 – 333840<br>
              </p>

              <p class="font-weight-medium">Operating Hours</p>
              
              <v-card class="px-12 py-8 mb-6">
                <v-table>
                  <thead>
                    <tr>
                      <th>Day</th>
                      <th>Hours</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Monday to Thursday</td>
                      <td>8am to 5pm</td>
                    </tr>
                    <tr>
                      <td>Friday</td>
                      <td>8am to 11.45pm<br>2.15pm to 5pm</td>
                    </tr>
                    <tr>
                      <td colspan="2">(Except Saturdays, sundays and public holidays)</td>
                    </tr>
                  </tbody>
                </v-table>
              </v-card>
            </v-col>


            
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
export default {
  name: 'ContactUsPage',
  data() {
    return {
      formData: {
        fullName: '',
        email: '',
        subject: '',
        message: '',
        rating: ''
      },
      mapUrl: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d127299.14505049387!2d113.988026!3d4.392704!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x321f48317b6f7f9d%3A0x97e1b6469e7fd774!2sMiri%20City%20Council!5e0!3m2!1sen!2sus!4v1721361198808!5m2!1sen!2sus'
    };
  },
  methods: {
    submitForm() {
      console.log('Form submitted:', this.formData);
    },
    resetForm() {
      this.formData = {
        fullName: '',
        email: '',
        subject: '',
        message: '',
        rating: ''
      };
      this.$refs.contactForm.reset();
    }
  }
};
</script>
